var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('van-loading',{attrs:{"size":"45px"}},[_vm._v("loading")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }